import React, { Component } from 'react';
import classNames from 'classnames';
import { PaddedSection } from '../../atoms';
import ContentConverter from '../../../utils/contentConverter';

import './styles.css';

/**
 * A simple template for a text area + image.
 *
 * @typedef {Object} Props
 * @prop {String} content
 * @prop {String} heading
 * @prop {Boolean} imageToRight
 * @prop {String} [imageClassName]
 *
 * @augments {Component<Props>}
 */
export default class TextImage extends Component {
	/**
	 * @param {Object} props
	 */
	genClassName = (props) => classNames('TextImage-image', props.imageClassName);

	/**
	 * @param {string} heading
	 */
	getHeading = (heading) => new ContentConverter(heading).nlToBr().getReactHtml();

	render () {
		const { content, heading, imageToRight } = this.props;

		return (
			<PaddedSection className={`TextImage${imageToRight ? ' imageToRight' : ''}`}>
				<div className='TextImage-text'>
					<h1 dangerouslySetInnerHTML={this.getHeading(heading)} />
					<p>{content}</p>
				</div>
				<div className={this.genClassName(this.props)} />
				{this.props.children}
			</PaddedSection>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/templates/TextImage/TextImage.js